module.exports = __webpack_public_path__ + "static/flags/CD-7aabd3376b6fccc4b519fca02a7afbd5.gif";